const updateCache = new Map<number, boolean>()

export function hasBeenUpdated(id: number): boolean {
    return updateCache.has(id)
}

export function markAsUpdated(id: number): void {
    updateCache.set(id, true)
}
